import { ButtonPrimeReact } from "@finanedi.es/storybook"
import Modal from "common/components/Modal/Modal"
import { INTEGRATIONS_LIST, Integration } from "constants/integrationsList"
import { useFlagProtection } from "hooks/useFlagProtection"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { INTEGRATION_UPDATE } from "routes/RoutePaths"
import ModalIntegracionForm from "./Components/ModalIntegration/ModalIntegracion"

export const Integraciones = () => {
  const isInterno = sessionStorage.getItem("isUserInterno") === "true"
  const flagIntegracionesUsuariosInternos = useFlagProtection(
    isInterno ? "integraciones_internos" : "integraciones_all_users"
  )
  const { t } = useTranslation()
  const history = useHistory()
  const [statusModal, setStatusModal] = useState<{
    show: boolean
    data: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      logo: $TSMigrationFixMe
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: $TSMigrationFixMe
    }
  }>({
    show: false,
    data: {
      logo: null,
      type: null,
    },
  })

  if (!flagIntegracionesUsuariosInternos) {
    return null
  }
  return (
    <>
      <div className='tw-bg-white tw-text-2xl tw-font-medium tw-text-shadow-default tw-text-left tw-border-0 tw-border-b tw-border-solid tw-border-gray-200 tw-mb-1 tw-py-4 tw-px-4'>
        {t("integracion.banner.title")}
      </div>
      <div className='tw-p-6 tw-grid sm:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-4 tw-gap-4'>
        {INTEGRATIONS_LIST(t).map((element: Integration) => {
          return (
            <div
              key={element.title}
              className='tw-flex tw-flex-col tw-items-center tw-p-6 tw-bg-simple-10 tw-text-right tw-rounded-lg tw-shadow-md'
            >
              <div className='tw-w-full tw-flex tw-justify-end'>
                <img
                  className='tw-h-12 tw-object-contain'
                  src={element.logo}
                  alt={element.title}
                />
              </div>
              <div className='tw-w-full tw-mt-8 tw-flex tw-flex-col'>
                <p className='tw-text-primary tw-text-2xl tw-font-medium !tw-mb-3 tw-text-start'>
                  {element.title}
                </p>
                <span className='tw-text-text-50 tw-text-sm tw-text-start'>
                  {element.text}
                </span>
              </div>

              <div className='tw-flex tw-w-full tw-justify-end tw-mt-6'>
                <ButtonPrimeReact
                  onClick={() =>
                    setStatusModal({
                      show: true,
                      data: {
                        logo: element.logo,
                        type: "sage",
                      },
                    })
                  }
                  className='!tw-bg-primary !tw-text-simnple-10 tw-px-4 tw-py-3'
                >
                  {t("integracion.importLabel")}
                </ButtonPrimeReact>
              </div>
            </div>
          )
        })}
      </div>
      <Modal
        visible={statusModal.show}
        onHide={() =>
          setStatusModal({
            show: false,
            data: {
              logo: null,
              type: null,
            },
          })
        }
        draggable
        header={
          <div className='tw-text-xl tw-font-medium tw-text-primary tw-text-start'>
            {t("integracion.modal.title")}
          </div>
        }
        className='!tw-w-[448px] tw-rounded-md'
      >
        <ModalIntegracionForm
          statusModal={statusModal}
          onCancel={() =>
            setStatusModal({
              show: false,
              data: {
                logo: null,
                type: null,
              },
            })
          }
          // eslint-disable-next-line no-console, @typescript-eslint/no-explicit-any
          onConfirm={(values: $TSMigrationFixMe) =>
            history.push(INTEGRATION_UPDATE, values)
          }
        />
      </Modal>
    </>
  )
}
